<template>
  <div style="margin: 1rem; padding: 1rem; width: 24rem;"  class="bg-modal" @click.stop>
    <text-item :txt="props.code" styles="font-l"/>
    <text-item :txt="props.description" class="mtop-02 linebreak cursor-sel" styles="main-m" style="max-width: 24rem;"/>
    <text-item txt="Court descriptif" class="mtop-10" styles="font-mBold"/>
    <inputBox class="mtop-03">
      <inputLineNew2 ref="inputRef" v-model="currDescription"/>
    </inputBox>
    <button-group class="mleft-08 mtop-10 psides-10" styles="border-h pad-s" style="margin-left: auto;" @click="addLuActToFavorites()">
      <text-item txt="Rajouter aux favoris" styles="font-mBold"/>
    </button-group>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import appuserapi from "@/api/appuserapi"
import { useAppUserStore } from '@/stores/appUser'
const appUserStore = useAppUserStore()

const inputRef = ref(null)

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
})
const emits = defineEmits(['close'])

const currDescription = ref("")

async function addLuActToFavorites() {
  const newDescription = " " + currDescription.value
  const newLine = props.code + newDescription.trimEnd()
  await appuserapi.addLuActFavorite(newLine)
  await appUserStore.setCurrentAppUserData()
  emits('close')
}

onMounted(() => {
  inputRef.value.innerRef.focus()
})

</script>

<style scoped>
</style>